<template>
  <div id="perfil_div">
    <v-breadcrumbs :items="crumbs">
        <v-breadcrumbs-item
            slot="item"
            slot-scope="{ item }"
            exact
            :to="item.to">
            {{ item.text.toUpperCase() }}
        </v-breadcrumbs-item>
    </v-breadcrumbs>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  components: { 
  },
  data: function() {
    return {

    };
  },
  computed: {
     crumbs: function()  {
        let pathArray = this.$route.matched;
        //pathArray.shift()
        let breadcrumbs = pathArray.reduce((breadcrumbArray, obj, idx) => 
        {
          breadcrumbArray.push({
            disabled: false,
            to: (obj.path.includes(":id") ? obj.path.replace(":id",parseInt(this.$route.params.id)) : obj.path),
            text: (obj.path.includes(":id") ? this.$route.params.agrupador : this.$route.matched[idx].meta.breadcrumb),
          });
          return breadcrumbArray;
        }, [])
        return breadcrumbs;
     }
  },
  watch: {
    
  },
  created () {

  },
  mounted() {
    //console.log(this.crumbs)
    //console.log(this.$route)
  },
  methods: {

  },
};
</script>